import React from "react";
import { AppBar, Avatar, IconButton, Toolbar, Tooltip, Typography } from "@material-ui/core";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import { makeStyles, useTheme } from "@material-ui/core/styles";

export const AGENTS_APP_BAR_OFFSET_PX = 84;

const WORKLOAD_LOGO = "https://cdn.workload.co/wp-content/uploads/new-logo-only-512-512.png";

/** Same exit target as the workflow editor AppBar. */
export const exitAgentsToDashboard = () => {
  const cookie = localStorage.getItem("tok_") || "";
  window.location.href = cookie
    ? `https://automate.workload.co/workflow?authToken=${encodeURIComponent(cookie)}`
    : "https://automate.workload.co/";
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.appBar,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbar: {
    minHeight: 56,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      minHeight: 64,
    },
  },
  menuButton: {
    marginRight: theme.spacing(0.5),
  },
  logoAvatar: {
    marginLeft: theme.spacing(1),
    width: 30,
    height: 30,
    [theme.breakpoints.up("md")]: {
      width: 40,
      height: 40,
      marginLeft: theme.spacing(2),
    },
  },
  title: {
    marginLeft: theme.spacing(1.5),
    fontWeight: 600,
    fontSize: "1.05rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.125rem",
    },
  },
  trailing: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginLeft: "auto",
  },
}));

/**
 * Minimal fixed toolbar for /agents routes — back chevron + Workload logo, optional title.
 * Uses theme.palette (light/dark) from brandingTheme.
 */
const AgentsAppBar = ({
  title,
  onBack,
  backTooltip = "Exit to dashboard",
  children,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const handleBack = onBack || exitAgentsToDashboard;

  return (
    <AppBar
      position="fixed"
      elevation={0}
      className={classes.appBar}
      style={{
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
      }}
    >
      <Toolbar className={classes.toolbar}>
        <Tooltip
          title={<span style={{ fontSize: 14 }}>{backTooltip}</span>}
          placement="bottom"
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label={backTooltip}
            onClick={handleBack}
            className={classes.menuButton}
          >
            <ChevronLeftRoundedIcon />
            <Avatar alt="Workload" src={WORKLOAD_LOGO} className={classes.logoAvatar} />
          </IconButton>
        </Tooltip>
        {title ? (
          <Typography variant="h6" component="div" className={classes.title} noWrap>
            {title}
          </Typography>
        ) : null}
        {children ? <div className={classes.trailing}>{children}</div> : null}
      </Toolbar>
    </AppBar>
  );
};

export default AgentsAppBar;
